import { ListagemConteudoEletronicoComponent } from "./../listagem-conteudo-eletronico/listagem-conteudo-eletronico.component";
import { ConteudoService } from "./../../../service/caixa/conteudo.service";
import { MatDialog } from "@angular/material/dialog";
import { DialogConfirmComponent } from "./../../dialog/dialog-confirm/dialog-confirm.component";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { FormControl } from "@angular/forms";
import { ClienteModel } from "app/model/cliente/cliente.model";
import { ClienteService } from "app/service/cliente/cliente.service";
import { MatTableDataSource, MatPaginator, MatSort } from "@angular/material";
import { CaixaService } from "./../../../service/caixa/caixa.service";
import { Router } from "@angular/router";
import { AuthenticationService } from "@alfresco/adf-core";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import * as CryptoJS from "crypto-js";

@Component({
  selector: "app-listar-conteudos",
  templateUrl: "./listar-conteudos.component.html",
  styleUrls: ["./listar-conteudos.component.scss"],
})
export class ListarConteudosComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  caixas: any[] = [];
  conteudos: any[] = [];
  displayedColumns = [
    "rgCaixa",
    "rgItem",
    "tipoRegistro",
    "dataInicial",
    "dataFinal",
    "origem",
    "descricao",
    // "estadoConservacao",
    "arquivistico",
    "idDoObjetoDocumento",
    // "destinacaoFinal",
    "numDocInicial",
    "numDocFinal",
    "status",
    "acoes",
  ];
  dataSource = new MatTableDataSource<any[]>([]);
  public clientes: ClienteModel[];
  queryField = new FormControl();
  public inputPesquisa = false;
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  public loading = false;
  idCaixa;
  clientePesquisado;
  adm = false;
  acervo = true;
  solicitacao = false;
  nomeClienteSelecionado;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private conteudoService: ConteudoService,
    private caixaService: CaixaService,
    private clienteService: ClienteService,
    private _snackBar: MatSnackBar,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) {
    iconRegistry.addSvgIcon(
      "addItens",
      sanitizer.bypassSecurityTrustResourceUrl(
        "../../../../assets/images/file-earmark-diff.svg"
      )
    );
  }

  ngOnInit() {
    this.listarClientesUsuario();
  }

  onChange() {
    let value = (<HTMLSelectElement>document.getElementById("selectCliente"))
      .value;
  }

  onSearch() {
    let selectedNumber = (<HTMLSelectElement>(
      document.getElementById("selectCliente")
    )).options.selectedIndex;
    this.nomeClienteSelecionado = (<HTMLSelectElement>(
      document.getElementById("selectCliente")
    )).options[selectedNumber].innerText;
    let value = (<HTMLSelectElement>document.getElementById("selectCliente"))
      .value;
    this.clientePesquisado = parseInt(value);
    if (parseInt(value) == 0) {
      this.openSnackBarError("Nenhum Cliente selecionado !");
      return null;
    }
    //this.getCaixas(parseInt(value));
    this.getConteudos(parseInt(value));
  }

  exibirConteudoEletronico(element) {
    const dialogRef = this.dialog.open(ListagemConteudoEletronicoComponent, {
      width: "100%",
      data: {
        conteudoId: element.id,
        descricaoConteudo: element.descricaoConteudo,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }

  pesquisaAvancanda() {
    const idCliente = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(this.clientePesquisado),
        "pcdoc"
      ).toString()
    );
    this.router.navigate(["pesquisa-avancada-conteudo", idCliente]);
  }

  fecharCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja fechar esta caixa ? Obs: Isso impossibilitará de incluir mais itens na caixa.",
        from: "listar-caixa.component.ts",
      },
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.fechaCaixaFunction(caixaId);
      }
    });
  }

  fechaCaixaFunction(idCaixa) {
    this.caixaService.fecharCaixa(idCaixa).subscribe(
      () => {
        this.openSnackBarSuccess("Caixa fechada com sucesso !");
        setTimeout(() => {
          this.getCaixas(this.clientePesquisado);
        }, 2000);
      },
      (err) => {
        this.openSnackBarError("Erro ao tentar fechar a caixa !");
        console.log(err);
      }
    );
  }

  abrirCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja abrir esta caixa ? Obs: Isso permitirá incluir mais itens na caixa.",
        from: "listar-caixa.component.ts",
      },
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.abrirCaixaFunction(caixaId);
      }
    });
  }

  abrirCaixaFunction(idCaixa) {
    this.caixaService.abrirCaixa(idCaixa).subscribe(
      () => {
        this.openSnackBarSuccess("Caixa aberta com sucesso !");
        setTimeout(() => {
          this.getCaixas(this.clientePesquisado);
        }, 2000);
      },
      (err) => {
        this.openSnackBarError("Erro ao tentar abrir a caixa !");
        console.log(err);
      }
    );
  }

  getCaixas(idCliente: number) {
    this.loading = true;
    this.caixaService.getCaixasIdCliente(idCliente).subscribe(
      (data) => {
        this.loading = false;
        if (data.length !== 0) {
          this.inputPesquisa = true;
        } else {
          this.inputPesquisa = false;
          this.openSnackBarError(`Nenhuma caixa encontrada neste Cliente !`);
        }
        this.caixas = data;
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  getConteudos(idCliente: number) {
    this.loading = true;
    this.conteudoService.getConteudosIdCliente(idCliente).subscribe(
      (data) => {
        console.log("Retorno da API:", data);
        this.loading = false;
        if (data.length !== 0) {
          this.inputPesquisa = true;
        } else {
          this.inputPesquisa = false;
          this.openSnackBarError(`Nenhum conteúdo encontrado neste Cliente !`);
        }
        this.conteudos = data;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(
      (data) => {
        this.clientes = data.content;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  deleteCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja apagar esta caixa ? Obs: Isso apagará todos os itens da caixa.",
        from: "listar-caixa.component.ts",
      },
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.apagarCaixa(caixaId);
      }
    });
  }

  editCaixa(caixaId: number) {
    this.idCaixa = encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(caixaId), "pcdoc").toString()
    );
    this.router.navigate(["/editar-caixa", this.idCaixa]);
  }

  apagarCaixa(caixaId: number) {
    this.loading = true;
    this.caixaService.apagarCaixa(caixaId).subscribe(
      () => {
        this.loading = false;
        this.getCaixas(this.clientePesquisado);
        this.openSnackBarSuccess("Caixa excluída com sucesso !");
      },
      (err) => {
        this.loading = false;
        this.openSnackBarError("Erro ao tentar excluír esta caixa !");
        console.error(err);
      }
    );
  }

  incluirIntens(id) {
    console.log(id);
    this.idCaixa = encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(id), "pcdoc").toString()
    );
    this.router.navigate(["/incluir-conteudo", this.idCaixa]);
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/listar-conteudos/listar-conteudos.component.ts